import queryString from 'query-string'
import { isEmpty } from 'lodash'

import { apiService, fetchingAPI } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'
import { setPlaybooks } from '@/reducers/playbooks/playbooks.redux'
import {
  setOrganization,
  setOrganizationAuditEvents,
  setIntegrationCredentials,
} from './organization.redux'
import { setUsers } from './organizationUsers.redux'
import { setOrganizationTags } from './organizationTags.redux'
import { setOrganizationTagCategories } from './organizationTagCategories.redux'
import { setOrganizationCustomBranding } from './organizationCustomBranding.redux'
import { setCustomBranding } from '../customBranding/customBranding.redux'
import { fetchOrganizations } from './organizations.actions'
import { closeModal } from '../ui/ui.redux'
import { formatFile } from './organization.helpers'

// TODO: Refactor toggleLoading
export const fetchOrganization =
  ({ organizationId, toggleLoading }) =>
  async (dispatch) => {
    try {
      const organization = await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationId}`,
        'GET',
        dispatch
      )
      dispatch(setOrganization(organization))
    } catch (err) {
      // catching error
    } finally {
      if (toggleLoading) toggleLoading()
    }
  }

export const fetchOrganizationAuditEvents =
  ({ organizationId, toggleLoading }) =>
  async (dispatch) => {
    try {
      const organization = await fetchingAPI(
        `${apiService.core}/api/audit_events/${organizationId}`,
        'GET',
        dispatch
      )
      dispatch(setOrganizationAuditEvents(organization))
    } catch (err) {
      // catching error
    } finally {
      if (toggleLoading) toggleLoading()
    }
  }

// TODO: Refactor toggleLoading
export const fetchOrganizationData =
  ({ organizationId, toggleLoading }) =>
  async (dispatch) => {
    const configProperties = queryString.stringify({
      requested_properties: 'id,name,cid,organization_id,config_active,config_agent_app_visibility',
    })

    const loadOrg = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}`,
      'GET',
      dispatch
    )
    const loadAllConfigs = fetchingAPI(
      `${apiService.core}/api/${organizationId}/configs?${configProperties}`,
      'GET',
      dispatch
    )
    const loadOrgUsers = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}/users`,
      'GET',
      dispatch
    )
    const loadOrgTags = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}/tags`,
      'GET',
      dispatch
    )
    const loadOrgTagCategories = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}/tags/categories`,
      'GET',
      dispatch
    )

    try {
      const [organization, playbooks, { users }, tags, tagCategories] = await Promise.all([
        loadOrg,
        loadAllConfigs,
        loadOrgUsers,
        loadOrgTags,
        loadOrgTagCategories,
      ])

      dispatch(setOrganization(organization))
      dispatch(setPlaybooks(playbooks))
      dispatch(setUsers(users))
      dispatch(setOrganizationTags(tags))
      dispatch(setOrganizationTagCategories(tagCategories))
    } catch (err) {
      // catching error
    } finally {
      if (toggleLoading) toggleLoading()
    }
  }

export const fetchOrganizationUsersAndTags =
  ({ organizationId, setLoading, modalClose }) =>
  async (dispatch) => {
    if (setLoading) setLoading(true)
    const loadOrgUsers = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}/users`,
      'GET',
      dispatch
    )
    const loadOrgTags = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}/tags`,
      'GET',
      dispatch
    )

    try {
      const [{ users }, tags] = await Promise.all([loadOrgUsers, loadOrgTags])

      dispatch(setUsers(users))
      dispatch(setOrganizationTags(tags))

      if (modalClose) modalClose()
    } catch (err) {
      // catching error
    } finally {
      if (setLoading) setLoading(false)
    }
  }

export const updateOrganizationProperties =
  ({ toggleLoading, organizationId, reloadOrganization, ...orgProps }) =>
  async (dispatch) => {
    const body = JSON.stringify({
      ...orgProps,
    })
    try {
      await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationId}`,
        'PATCH',
        dispatch,
        body
      )
      toast.success('Organization updated successfully!')
      dispatch(reloadOrganization({ organizationId, toggleLoading }))
    } catch (err) {
      toast.error(err?.message || 'Failed to update organization.')
      if (toggleLoading) toggleLoading()
    }
  }

export const generatePassphrase = (updatePassphrase) => async (dispatch) => {
  try {
    const passphrase = await fetchingAPI(
      `${apiService.auth}/api/generate_password`,
      'GET',
      dispatch
    )
    updatePassphrase(passphrase)
  } catch (err) {
    console.error('generatePassphrase failed', err)
  }
}

// TODO: Convert to async/await
export const reportPassphrase = (badPassphrase) => (dispatch) => {
  fetchingAPI(
    `${apiService.auth}/api/report_password`,
    'POST',
    dispatch,
    JSON.stringify(badPassphrase)
  )
    .then((reportedPassphrase) => toast.success(`${reportedPassphrase} has been reported.`))
    .catch(() => {})
}

// TODO: Convert to async/await
export const generateTemporaryLink = (updateTempLinkExpiration, userData) => (dispatch) => {
  const body = JSON.stringify(userData)

  fetchingAPI(`${apiService.auth}/api/reset_password`, 'POST', dispatch, body)
    .then(({ expiration, link }) => {
      updateTempLinkExpiration(expiration, link)
    })
    .catch((err) => console.error('generateTemporaryLink failed', err))
}

// TODO: Refactor alert
export const deleteDesktopTokens =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      const orgName = await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationId}/desktop_tokens`,
        'DELETE',
        dispatch
      )
      toast.success(`All desktop tokens for ${orgName} have been deleted`)
    } catch {}
  }

export const deleteOrganization =
  ({ organizationId, push }) =>
  async (dispatch) => {
    try {
      await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationId}`,
        'DELETE',
        dispatch
      )
      dispatch(fetchOrganizations())

      push('/organizations')
    } catch (err) {
      // catching error
    }
  }

export const handleFileUploadResponse = async (response) => {
  const { status } = response

  if (status > 400) {
    throw new Error()
  }
  const body = await response.json()

  if (response.status === 400) {
    const { error } = body
    throw new Error(error)
  }

  return body
}

const uploadFile = async (key, fileArr, organizationId, currentUser) => {
  const formattedFile = formatFile(key, fileArr)

  const body = new FormData()
  body.append('file', formattedFile)

  return fetch(`${apiService.core}/api/organizations/${organizationId}/files`, {
    method: 'PUT',
    // Content-Type headers breaks this request
    // that's why this is a separate fetch
    headers: {
      username: currentUser.username,
      token: currentUser.token,
      organizationid: currentUser.organizationid,
    },
    body,
  }).then(handleFileUploadResponse)
}

export const fetchIntegrationCredentials =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      const credentials = await fetchingAPI(
        `${apiService.core}/api/integration/credentials/${organizationId}`,
        'GET',
        dispatch
      )
      dispatch(setIntegrationCredentials(credentials))
    } catch (error) {
      dispatch(setIntegrationCredentials([]))
    }
  }

export const testIntegrationCredential =
  ({ organizationId, provider, credentials }) =>
  async (dispatch) => {
    try {
      const response = await fetchingAPI(
        `${apiService.core}/api/integration/credentials/${organizationId}/${provider}/test`,
        'POST',
        dispatch,
        JSON.stringify({ credentials })
      )
      return response
    } catch (error) {
      return { ok: false, detail: 'Request failed' }
    }
  }

export const upsertIntegrationCredential =
  ({ organizationId, provider, credentials, metadata, onSuccess }) =>
  async (dispatch) => {
    try {
      // `metadata` carries non-secret provider settings stored outside the
      // encrypted blob (e.g. NICE CXone ingestion_delay_seconds). Omitted
      // entirely when absent/empty, so the backend treats it as "no change"
      // rather than "clear".
      await fetchingAPI(
        `${apiService.core}/api/integration/credentials/${organizationId}/${provider}`,
        'PUT',
        dispatch,
        JSON.stringify(isEmpty(metadata) ? { credentials } : { credentials, metadata })
      )
      toast.success('Integration credentials saved')
      dispatch(fetchIntegrationCredentials({ organizationId }))
      if (onSuccess) {
        onSuccess()
      }
    } catch (error) {
      toast.error('Failed to save integration credentials', { cause: error })
    }
  }

export const deactivateIntegrationCredential =
  ({ organizationId, provider }) =>
  async (dispatch) => {
    try {
      await fetchingAPI(
        `${apiService.core}/api/integration/credentials/${organizationId}/${provider}`,
        'DELETE',
        dispatch
      )
      toast.success('Integration credentials deactivated')
      dispatch(fetchIntegrationCredentials({ organizationId }))
    } catch (error) {
      toast.error('Failed to deactivate integration credentials', { cause: error })
    }
  }

// Fetches the Slack 'Add to Slack' authorize URL for an org. The component
// redirects the browser to the returned URL; the backend signs the org +
// returnTo into the OAuth `state` so its (unauthenticated) callback can
// persist the workspace bot token to the right org and land the user back
// where they started. `requested_organization_id` is what authorize_for_org
// reads to scope access (Balto admins any org, org admins their own).
export const getSlackOAuthUrl =
  ({ organizationId, returnTo }) =>
  async (dispatch) => {
    try {
      const params = queryString.stringify({
        requested_organization_id: organizationId,
        return_to: returnTo,
      })
      const response = await fetchingAPI(
        `${apiService.core}/api/integration/slack/oauth/url?${params}`,
        'GET',
        dispatch
      )
      return response.url
    } catch (error) {
      toast.error('Could not start Slack install. Is the Balto Slack app configured?', {
        cause: error,
      })
      return null
    }
  }

// Lightweight org-accessible check of whether Slack is connected, so the
// self-serve button can show Connect vs. Change workspace/Disconnect. Returns
// { connected, last_updated }; defaults to disconnected on error.
export const fetchSlackStatus =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      return await fetchingAPI(
        `${apiService.core}/api/integration/slack/status?${queryString.stringify({
          requested_organization_id: organizationId,
        })}`,
        'GET',
        dispatch
      )
    } catch (error) {
      return { connected: false }
    }
  }

export const disconnectSlack =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      await fetchingAPI(
        `${apiService.core}/api/integration/slack/credential?${queryString.stringify({
          requested_organization_id: organizationId,
        })}`,
        'DELETE',
        dispatch
      )
      toast.success('Slack disconnected')
      return true
    } catch (error) {
      toast.error('Failed to disconnect Slack', { cause: error })
      return false
    }
  }

// Teams uses Microsoft's admin-consent flow rather than per-user OAuth: the
// URL endpoint returns a consent link a tenant admin approves, after which the
// callback records the tenant. Same Connect/Reconnect/Disconnect shape as Slack.
export const getTeamsOAuthUrl =
  ({ organizationId, returnTo }) =>
  async (dispatch) => {
    try {
      const params = queryString.stringify({
        requested_organization_id: organizationId,
        return_to: returnTo,
      })
      const response = await fetchingAPI(
        `${apiService.core}/api/integration/teams/oauth/url?${params}`,
        'GET',
        dispatch
      )
      return response.url
    } catch (error) {
      toast.error('Could not start Teams setup. Is the Balto Teams app configured?', {
        cause: error,
      })
      return null
    }
  }

export const fetchTeamsStatus =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      return await fetchingAPI(
        `${apiService.core}/api/integration/teams/status?${queryString.stringify({
          requested_organization_id: organizationId,
        })}`,
        'GET',
        dispatch
      )
    } catch (error) {
      return { connected: false }
    }
  }

export const disconnectTeams =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      await fetchingAPI(
        `${apiService.core}/api/integration/teams/credential?${queryString.stringify({
          requested_organization_id: organizationId,
        })}`,
        'DELETE',
        dispatch
      )
      toast.success('Teams disconnected')
      return true
    } catch (error) {
      toast.error('Failed to disconnect Teams', { cause: error })
      return false
    }
  }

export const uploadCustomizationOptions =
  (
    {
      customBrandingDisplayName,
      customBrandingPrimaryColor,
      customBrandingSecondaryColor,
      faviconUrl,
      iconLightUrl,
      iconDarkUrl,
    },
    organizationId
  ) =>
  async (dispatch, getState) => {
    const { currentUser } = getState()
    const shouldUpdateCurrentUser = organizationId === currentUser.organizationid

    const customBrandingJSON = JSON.stringify({
      custom_branding_display_name: customBrandingDisplayName,
      custom_branding_theme: customBrandingPrimaryColor
        ? {
            primary_color: customBrandingPrimaryColor,
            secondary_color: customBrandingSecondaryColor,
          }
        : null,
    })
    const customBrandingRequest = fetchingAPI(
      `${apiService.core}/api/organizations/${organizationId}`,
      'PATCH',
      dispatch,
      customBrandingJSON
    )
    const faviconRequest = faviconUrl
      ? uploadFile('favicon', faviconUrl, organizationId, currentUser)
      : null
    const iconLightRequest = iconLightUrl
      ? uploadFile('icon-light', iconLightUrl, organizationId, currentUser)
      : null
    const iconDarkRequest = iconDarkUrl
      ? uploadFile('icon-dark', iconDarkUrl, organizationId, currentUser)
      : null

    const pendingRequests = [
      customBrandingRequest,
      faviconRequest,
      iconLightRequest,
      iconDarkRequest,
    ]

    try {
      await Promise.all(pendingRequests)

      // Fetch the latest
      const customBranding = await fetchingAPI(
        `${apiService.core}/api/custom_branding/${organizationId}`,
        'GET',
        dispatch
      )

      dispatch(setOrganizationCustomBranding(customBranding))

      if (shouldUpdateCurrentUser) {
        dispatch(setCustomBranding(customBranding))
      }
      dispatch(closeModal())

      toast.success('Custom branding options saved!')
    } catch (err) {
      let message = 'Failed to upload custom branding options.'
      if (err?.message) {
        message += ` ${err.message}`
      }

      toast.error(message, { cause: err })
    }
  }
